import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import * as styles from './PageHeader.module.scss'

const PageHeader = ({ title, description, video, dark, alignLeft }) => {
  const [open, setOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    // Initial check
    handleResize()

    // Attach the event listeners
    window.addEventListener('resize', handleResize)

    // Cleanup function
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const videoRef = useRef()

  const handleFullscreenClick = () => {
    if (videoRef.current.requestFullscreen) {
      videoRef.current.requestFullscreen()
    } else if (videoRef.current.mozRequestFullScreen) {
      // Firefox
      videoRef.current.mozRequestFullScreen()
    } else if (videoRef.current.webkitRequestFullscreen) {
      // Chrome, Safari and Opera
      videoRef.current.webkitRequestFullscreen()
    } else if (videoRef.current.msRequestFullscreen) {
      // IE/Edge
      videoRef.current.msRequestFullscreen()
    } else if (videoRef.current.webkitEnterFullscreen) {
      // iOS Safari
      videoRef.current.webkitEnterFullscreen()
    }
  }

  return (
    <>
      <div className={`${styles.header} ${dark ? styles.dark : ''} ${alignLeft ? styles.alignLeft : ''}`}>
        <div className={styles.headerContent}>
          <div className={styles.heading}>
            <h1 className={styles.title}>{title}</h1>
            <div className={styles.descriptionContainer}>
              <div>
                <p>{description}</p>
              </div>
            </div>
          </div>
          {video && (
            <div
              className={styles.heroPromo}
              onClick={() =>
                !isMobile ? setOpen(true) : handleFullscreenClick()
              }
            >
              <video
                src={video}
                loop
                autoPlay
                muted
                playsInline={true}
                webkit-playsinline="true"
                x5-playsinline="true"
                ref={videoRef}
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: 0,
                  display: 'block',
                  objectFit: 'cover',
                  backgroundColor: 'rgba(0, 0, 0, 0)',
                  objectPosition: '50% 50%'
                }}
              ></video>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  dark: PropTypes.bool,
  alignLeft: PropTypes.bool
}

export default PageHeader
